export default __webpack_public_path__ + "static/media/Clear_Sky.af468405.jpg";